import fetch from '@/utils/fetch';

export default {
  // 获取DDF参评类型
  getDDFPrize: params => {
    return fetch({
      url: 'inquiry/ddf-prize',
      method: 'get',
      params
    })
  },

  // 获取DDF报名人员列表
  getDDFRegistration: params => {
    return fetch({
      url: 'inquiry/ddf-participant',
      method: 'get',
      params
    })
  },

  // 投票
  voteDdf: data => {
    return fetch({
      url: 'ddf-vote',
      method: 'post',
      data
    })
  },

  // 获取用户投票信息
  getUserDdfVote: params => {
    return fetch({
      url: 'inquiry/ddf-vote',
      method: 'get',
      params
    })
  },
}